// import { createApp } from 'vue'
import { createStore } from 'vuex'

import Loading from 'quasar/src/plugins/loading/Loading.js';import QSpinnerBall from 'quasar/src/components/spinner/QSpinnerBall.js';

// var URL = 'http://10.91.178.2:5033/';
// var URL = 'http://localhost:5033/';
// var URL = 'http://192.168.1.17:5033/';

var URL = 'https://servermarina.konaweselatankab.go.id/';

const store = createStore({
  state: {
    url : {
      URL_APP : URL,
      URL_AUTHENTIKASI : URL + "api/v1/auth_publish/",
      URL_BERANDA : URL + "api/v1/beranda_publish/",
      URL_PRODUK : URL + "api/v1/produk_publish/",
      URL_KERANJANG : URL + "api/v1/keranjang_publish/",
      URL_WISHLIST : URL + "api/v1/favorite_publish/",
      URL_AKUN : URL + "api/v1/akun_publish/",
      // WA : "http://wa-api.konaweselatankab.go.id/api",
    }
  },
  getters: {
  },
  mutations: {
    getStorage(state){
      var get_profile = JSON.parse(localStorage.profile);
      state.unit_kerja = get_profile.profile.unit_kerja; 
    },
    showLoading(){
      Loading.show({
        spinner : QSpinnerBall,
        spinnerColor: 'purple-12',
        spinnerSize: 140,
        backgroundColor: 'grey-2',
        // message: 'Loading... Tunggu beberapa saat, system sedang menyesuaikan akun anda..!',
        // messageColor: 'white'
      })
    },
    hideLoading(){
      Loading.hide()
    },
  },
  actions: {
  },
  modules: {
  }
})

export default store;
